module.exports = __webpack_public_path__ + "img/3bed0f4.jpg";